 $('.quotes-slider').slick({
  dots: false,
  infinite: true,
  speed: 300,
  slidesToShow: 3,
  slidesToScroll: 1,
       arrows:false,
     autoplay: true,
 prevArrow:'<button type="button" class="slick-prev-logo"> <i class="fa fa-angle-left"></i></button>',
nextArrow:'<button type="button" class="slick-next-logo"> <i class="fa fa-angle-right"></i></button>',

  responsive: [
     {
      breakpoint: 1280,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true,
        dots: false,
        autoplay: true
        
      }
         },
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true,
        dots: false
      }
   
     },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
});


// blog filter

$('.select-group select').on('change', function() {
    var m_article = $(this).find('option:selected').val();
    console.log(m_article);

    var selectedUrl = $(this).val();

    if (selectedUrl) {
        window.location.href = selectedUrl;
    }
});


$('.vedio-slider').slick({
  dots: false,
  infinite: true,
  // speed: 300,
  slidesToShow: 1,
  slidesToScroll: 1,
       arrows: true,
   adaptiveHeight: true,
 prevArrow:'<button type="button" class="slick-prev-logo1"> <i class="fa fa-angle-left"></i></button>',
nextArrow:'<button type="button" class="slick-next-logo1"> <i class="fa fa-angle-right"></i></button>',

  responsive: [
     {
      breakpoint: 1280,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        
      }
         },
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        dots: false
      }
   
     },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
});

// navigation hover effect

$(document).ready(function () {
    $(".newww_click summary").click(function (event) {
        $(".acc-body").not($(this).next(".acc-body")).hide();
        $(this).next(".acc-body").toggle();
        $(this).find('.icon-caret').toggleClass('rotate');
    });
});

// $(document).ready(function () {
//       $(".newww_click").find(".acc-body").hide();

//     $(".newww_click").hover(
//         function () {
//             $(this).find(".acc-body").show();
//             $(this).find('.icon-caret').addClass('rotate');
//         },
//         function () {
//             $(this).find(".acc-body").hide();
//             $(this).find('.icon-caret').removeClass('rotate');
//         }
//     );


  
// });

$(document).ready(function () {
    $(".newww_click").find(".acc-body").hide();

    $(".newww_click").hover(
        function () {
            $(this).find(".acc-body").show().addClass("your-new-class"); // Add the new class here
            $(this).find('.icon-caret').addClass('rotate');
        },
        function () {
            $(this).find(".acc-body").hide().removeClass("your-new-class"); // Remove the new class here
            $(this).find('.icon-caret').removeClass('rotate');
        }
    );
});
